module.exports = __webpack_public_path__ + "static/media/cancelIcon.82d73897.svg";